import { render, staticRenderFns } from "./composicao.vue?vue&type=template&id=1dafd60e&"
import script from "./composicao.vue?vue&type=script&lang=js&"
export * from "./composicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports